module.exports = __webpack_public_path__ + "static/okauto_logo_new-3db6fdfd25443f4901881699cbb700fa.svg";